const Status = [
  {
    id: 1,
    name: 'Open',
    label: 'Open',
  },
  {
    id: 2,
    name: 'Closed',
    label: 'Closed',
  },
];

export default Status;
